import { toast } from 'react-toastify';

const Mensagens = {
  showSucesso: (msg, options) => toast.success(msg, options),
  showInfo: (msg, autoClose = true) => toast.info(msg, { autoClose: autoClose }),
  showWarning: (msg, options) => toast.warning(msg, options),
  showErro: (msg, options) => toast.error(typeof (msg) === 'string' ? msg : "Ocorreu um erro!", options),
  showLoading: (cb, loadingMsg, sucessMsg, errorMsg) => toast.promise(cb, { pending: loadingMsg, success: sucessMsg, error: errorMsg })
};

export default Mensagens;
